import { useState } from "react";

import {
    Grid,
    Tab,
    Tabs,
} from "@mui/material";

import MDBox from "../../../components/MDBox";
import AssetCard from "../../../components/AssetCard";

function IncludedAssetsTab({assetsData}) {
    const [selectedInnerAssetTab, updateSelectedInnerAssetTab] = useState(0);
    return (
        <Grid container sx={{mt: 1}}>
            <MDBox display="flex" >
                <Tabs
                    value={selectedInnerAssetTab}
                    onChange={(_, index) => updateSelectedInnerAssetTab(index)}
                    orientation="horizontal"
                >
                    <Tab label="Asset Card View" sx={{p: 1}}/>
                    <Tab label="Asset Matrix" sx={{p: 1}}/>
                </Tabs>
            </MDBox>

            <MDBox flex="auto" bgColor="grey-100" borderRadius="lg" width="100%">
                {selectedInnerAssetTab === 0 && (<Grid container
                sx={{display: "flex", 
                    overflowX: "auto",
                    width: "100%",
                    maxHeight: "calc(100vh * .59)"
                }}>
                    {assetsData.map((item) => (
                        <Grid item px={1} my={1} xs={6} md={4} lg={4} sx={{display: "flex", minWidth: "250px"}}>
                            <AssetCard 
                                image={item.image} 
                                label={item.label} 
                                title={item.title} 
                                description={item.description}
                                specs={item.specs}
                                capabilities={item.capabilities}    
                            />
                        </Grid>
                    ))}
                </Grid>)}

                {selectedInnerAssetTab === 1 && (
                    <MDBox bgColor="gray-100" sx={{width: "100%", display: "flex"}}>
                        
                    </MDBox>
                )}
            </MDBox>
        </Grid>
    );
}

export default IncludedAssetsTab;